import axios from "axios";
import { useNavigate } from "react-router-dom";
import DashNav from "../Dashboard/DashNav.js";
import * as React from "react";
import Stack from "@mui/material/Stack";
import Sidebar from "../Dashboard/Sidebar.js";
import Feed from "../Dashboard/Feed";
import { Box } from "@mui/system";
import {
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { DataGrid, GridToolbar, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { ToastContainer, toast } from "react-toastify";
import { DirectionsCar, Add, Edit, Delete } from "@mui/icons-material";

const carBrandNames = require("./VehicleBrands.js");

// --- MODERN STYLED COMPONENTS ---

const RootContainer = styled(Box)({
  background: "#F8FAFC",
  minHeight: "100vh",
  display: "flex",
});

const ContentArea = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  marginLeft: "18vw",
  padding: "40px",
  width: "calc(100% - 18vw)",
  transition: "all 0.3s ease",
  [theme.breakpoints.down("md")]: {
    marginLeft: 0,
    width: "100%",
    padding: "20px",
    paddingTop: "84px",
  },
}));

const GlassCard = styled(Paper)({
  padding: "24px",
  borderRadius: "16px",
  background: "#FFFFFF",
  border: "1px solid #E2E8F0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
});

const StyledDataGrid = styled(DataGrid)({
  border: "none",
  backgroundColor: "#FFFFFF",
  borderRadius: "16px",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#F1F5F9",
    color: "#475569",
    fontWeight: 700,
    fontSize: "14px",
    borderBottom: "1px solid #E2E8F0",
  },
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #F1F5F9",
    color: "#1E293B",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #E2E8F0",
  },
  "& .wrap-text": {
    whiteSpace: "normal",
  },
});

const ModalBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500px",
  maxHeight: "90vh",
  overflowY: "auto",
  backgroundColor: "#FFFFFF",
  borderRadius: "20px",
  boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
  outline: "none",
  [theme.breakpoints.down("sm")]: {
    width: "95%",
  },
}));


function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 0.5,
        pb: 0,
      }}
    >
      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) =>
          searchInput
            .split(',')
            .map((value) => value.trim())
            .filter((value) => value !== '')
        }
      />
    </Box>
  );
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  border: "2px solid ",
  boxShadow: 24,
  p: 4,
};



function VehicleModels() {
  return (
    <RootContainer>
      <Sidebar />
      <CarModels />
    </RootContainer>
  );
}
const CarModels = () => {

    // Datagrid Columns
    const columns = [
        {
          field: "col0",
          headerName: "Actions",
          width: 220,
          sortable: false,
          filterable: false,
          renderCell: (cellValues) => {
            return (

              <Stack direction="row" spacing={1}>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<Edit />}
                  onClick={(event) => {
                    handleEdit(event, cellValues);
                  }}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "none",
                    borderColor: "#3B82F6",
                    color: "#3B82F6",
                    "&:hover": { borderColor: "#2563EB", bgcolor: "#eff6ff" }
                  }}
                >
                  Edit
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  color="error"
                  startIcon={<Delete />}
                  onClick={(event) => {
                    handleDelete(event, cellValues);
                  }}
                  sx={{
                    borderRadius: "8px",
                    textTransform: "none",
                    "&:hover": { bgcolor: "#fef2f2" }
                  }}
                >
                  Delete
                </Button>
              </Stack>
            );

          },
        },
        { field: "uid", sortable: false, headerName: "UID", width: 300, filterable: false },
        {
          field: "brandName",
          sortable: false,
          headerName: "Vehicle Brand",
          width: 260,
        },
        {
          field: "ModelName",
          sortable: false,
          headerName: "Vehicle Model",
          width: 270,
        },
        { field: "createdAt", sortable: false, headerName: "CreatedAt", width: 210,
        valueFormatter: (params) => {
          const valueFormatted = new Date(params.value).toDateString();
          return `${valueFormatted}`;
        }, },
        { field: "updatedAt", sortable: false, headerName: "UpdatedAt", width: 210 ,valueFormatter: (params) => {
          const valueFormatted = new Date(params.value).toDateString();
          return `${valueFormatted}`;
        },},
      ];
      





  const [existingVehicleModels, setexistingVehicleModels] = React.useState([]);
  //isUpdating State is used for checking if the modal open is for updating or adding a new one hence changing the button name 
  const [IsUpdating, setIsUpdating] = React.useState(false)
  const [isLoading, setisLoading] = React.useState(false)
  const [newModel, setNewModel] = React.useState({
    brand: "",
    modelname: "",
  });
  const [vehicleBrandName, setvehicleBrandName] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const handleOpenDelete = () => setOpenDelete(true);
  const handleCloseDelete = () => setOpenDelete(false);








  const handleOpen = () => {
    setNewModel([])
    setOpen(true)
  };
  const handleClose = () => {
    setOpen(false);
    setIsUpdating(false)
  };

  const handleBrandChange = (event) => {
    const {
      target: { value },
    } = event;
    setvehicleBrandName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    handleChange(event);
  };


  function handleChange(evt) {
    const value = evt.target.value;
    setNewModel({
      ...newModel,
      [evt.target.name]: value,
    });
  }

  function handleEdit(Event,Value){

    setOpen(true)
    setNewModel({
        brand:Value.row.brandName,
        modelname:Value.row.ModelName,
        inputUUID:Value.row.uid
    })
    setIsUpdating(true)
  }

     async function handleDelete(Event,Value){
       
        if (window.confirm("You surely want to delete this Vehicle Model?")) {
          await deleteVehicleModel(Value.row.uid) 
        }      // await deleteVehicleModel(Value.row.uid) 
        else{
          await getAllVehicleModels()
        }
     }


   const getAllVehicleModels = async () => {
            setisLoading(true)
            const token = localStorage.getItem("accessToken");
            const config = {
              headers: {
                auth: token,
              },
            };
             axios
              .get("/vehiclemodels", config)
              .then((response) => {
                setexistingVehicleModels(response.data.data);
                setisLoading(false)
              });
  };
  React.useEffect(() => {
    getAllVehicleModels();
  }, []);

  const addNewVehicleModel = async () => {
    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        auth: token,
      },
    };
    await axios
      .post("/addVehicleModel", newModel, config)
      .then((response) => {
        toast.success("Model Added Successfully!");
        setOpen(false)
        setvehicleBrandName([])
        getAllVehicleModels()
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.error == "Model Already Exists") {
          toast.error("Model Already Exists");
        } else {
          toast.error("Model Cannot Be Added");
        }
      });
  };
  const updateVehicleModel = async () => {
    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        auth: token,
      },
    };
    await axios
      .put("/updateVehicleModel", newModel, config)
      .then((response) => {

        toast.success("Model Updated Successfully!");
        setOpen(false)
        setvehicleBrandName([])
        getAllVehicleModels()
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.error == "Model Already Exists") {
          toast.error("Model Already Exists");
        } else {
          toast.error("Model Cannot Be Updated");
        }
      }); 
  }

  const deleteVehicleModel = async (uid) => {
    const token = localStorage.getItem("accessToken");
    const config = {
      headers: {
        auth: token,
      },
    };
    await axios
      .delete(`/deleteVehicleModel/${uid}`,  config)
      .then((response) => {
        toast.success("Model Deleted Successfully!");
        setOpen(false)
        setvehicleBrandName([])
        getAllVehicleModels()
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.error == "Model Already Exists") {
          toast.error("Model Already Exists");
        } else {
          toast.error("Model Cannot Be Deleted");
        }
      }); 
  }
  return (
    <ContentArea>
      {/* HEADER SECTION */}
      <Stack 
        direction={{ xs: "column", md: "row" }} 
        justifyContent="space-between" 
        alignItems={{ xs: "flex-start", md: "center" }} 
        spacing={3}
        sx={{ mb: 4 }}
      >
        <Box>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: "#1E293B",
              fontFamily: "Kamerik",
              letterSpacing: "-1.5px",
              fontSize: { xs: "2rem", md: "3rem" }
            }}
          >
            Manage Models
          </Typography>
          <Typography variant="body2" sx={{ color: "#64748B", fontWeight: 500 }}>
            Configure vehicle brands and their associated models
          </Typography>
        </Box>

        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={handleOpen}
          sx={{
            borderRadius: "12px",
            px: 3,
            bgcolor: "#1E293B",
            fontWeight: 700,
            height: "48px",
            "&:hover": { bgcolor: "#0F172A" },
            width: { xs: "100%", md: "auto" }
          }}
        >
          Add Model
        </Button>
      </Stack>

      <GlassCard elevation={0}>
        <Box sx={{ height: "70vh", width: "100%" }}>
          <StyledDataGrid
            rows={existingVehicleModels}
            columns={columns}
            pageSize={50}
            disableSelectionOnClick
            loading={isLoading}
            components={{
              Toolbar: GridToolbar,
            }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 }
              },
            }}
            sortModel={[
              {
                field: 'createdAt',
                sort: 'desc',
              }
            ]}
            rowsPerPageOptions={[10, 25, 50, 100]}
            sx={{
              "& .MuiDataGrid-toolbarContainer": {
                padding: "16px",
                gap: "12px",
                borderBottom: "1px solid #E2E8F0",
                "& .MuiButton-root": {
                  color: "#64748B",
                  fontWeight: 700,
                  "&:hover": {
                    color: "#1E293B",
                  },
                },
              },
            }}
          />
        </Box>
      </GlassCard>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <ModalBox>
          <Box
            sx={{
              p: 3,
              background: "linear-gradient(135deg, #1E293B 0%, #0F172A 100%)",
              color: "#fff",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 800, display: "flex", alignItems: "center", gap: 1 }}>
              <DirectionsCar /> {IsUpdating ? "Update Model" : "Add New Model"}
            </Typography>
          </Box>

          <Box sx={{ p: 4 }}>
            <Stack spacing={3}>
              <FormControl fullWidth>
                <InputLabel>Vehicle Brand</InputLabel>
                <Select
                  value={newModel.brand || ""}
                  onChange={handleBrandChange}
                  name="brand"
                  label="Vehicle Brand"
                  sx={{ borderRadius: "12px" }}
                >
                  {carBrandNames.map((name) => (
                    <MenuItem key={name} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <TextField
                label="Model Name"
                variant="outlined"
                fullWidth
                name="modelname"
                onChange={handleChange}
                value={newModel.modelname || ""}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              />

              <Button
                variant="contained"
                fullWidth
                size="large"
                onClick={IsUpdating ? updateVehicleModel : addNewVehicleModel}
                sx={{
                  mt: 2,
                  height: "56px",
                  borderRadius: "12px",
                  bgcolor: "#3B82F6",
                  fontSize: "1rem",
                  fontWeight: 700,
                  "&:hover": { bgcolor: "#2563EB" },
                }}
              >
                {IsUpdating ? "Update Model" : "Add Model"}
              </Button>
            </Stack>
          </Box>
        </ModalBox>
      </Modal>






      <ToastContainer position="bottom-right" />
    </ContentArea>
  );
};
export default VehicleModels;
